import Vue from 'vue';
import App from '@app/core/deposit/App';
import createStore from '@app/store/modules/deposit';
import { fixDefaults } from '@app/services/deposit/fixDefaults';

Vue.config.productionTip = false;

export default {
    init({ data, externalHandler } = {}) {
        const fixed = fixDefaults(data);
        const store = createStore({ data: fixed });

        return new Vue({
            store,
            render: (h) => h(App, { props: { externalHandler } }),
        }).$mount('#app');
    },
};
